const doc = [({"zh_cn":({"adminHotelMail":({"saveInformation":"保存 {{type}} 的笔记", "saveSetting":"保存电子邮件设置"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;